import NoData from 'components/noData/noData';
import styles from './dashboardList.module.scss';
import { Button, Table, TableProps } from 'antd';

interface Data {
	title: string;
	column1: number;
	column1Change: number;
	column2: number;
	column2Change: number;
}

interface InputProps {
	title: string;
	subTitle: string;
	tableHeader: string[];
	data: Data[];
}

function DashboardListComponent({ title, subTitle, tableHeader, data }: InputProps) {
	const columns: TableProps<Data>['columns'] = [
		{
			title: tableHeader[0],
			dataIndex: tableHeader[0],
			key: tableHeader[0],
			render: (itemData, rowData) => <span>{rowData.title}</span>,
		},
		{
			title: tableHeader[1],
			dataIndex: tableHeader[1],
			key: tableHeader[1],
			render: (itemData, rowData) => (
				<>
					<span className="me-3">{rowData.column1}</span>
					<span style={{ color: rowData.column1Change > 0 ? '#50CD89' : '#F1416C' }}>{rowData.column1Change}</span>
				</>
			),
		},
		{
			title: tableHeader[2],
			dataIndex: tableHeader[2],
			key: tableHeader[2],
			render: (itemData, rowData) => (
				<>
					<span className="me-3">{rowData.column2}%</span>
					<span style={{ color: rowData.column2Change > 0 ? '#50CD89' : '#F1416C' }}>{rowData.column2Change}%</span>
				</>
			),
		},
	];

	return (
		<div className={styles.container}>
			<header>
				<div>
					<h5>{title}</h5>
					<p>{subTitle}</p>
				</div>
				<Button className="discard">PDF Report</Button>
			</header>
			<main>
				<Table columns={columns} dataSource={data} scroll={{ x: 400 }} pagination={false} 
							locale={{ emptyText: <NoData /> }}
							/>
			</main>
		</div>
	);
}

export default DashboardListComponent;
